import { DropdownMenu, DropdownMenuItem } from '@/components/Elements';
import { ChevronDownIcon, GlobeAltIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import i18n from 'i18next';

interface language {
  [key: string]: string;
}

const LANGUAGES: language = {
  ja: '日本語',
  en: 'English',
};

type Props = {
  theme?: 'black' | 'white';
};

export const LanguageSwitcher = ({ theme = 'black' }: Props) => {
  const currentLanguage = LANGUAGES[i18n.language];

  const handleLanguageChange = (languageKey: string) => {
    i18n.changeLanguage(languageKey);
  };

  return (
    <DropdownMenu
      trigger={
        <div
          className={clsx(
            'relative flex cursor-default items-center gap-x-1.5 rounded-2xl px-3 py-1.5 ring-1 ring-inset',
            theme === 'black' ? 'ring-black' : 'text-white ring-white'
          )}
        >
          <GlobeAltIcon className="hidden size-6 sm:block" />
          {currentLanguage}
          <ChevronDownIcon className="size-3" />
        </div>
      }
      className="z-50"
      matchTriggerWidth
    >
      {Object.keys(LANGUAGES).map((languageKey) => (
        <DropdownMenuItem
          key={languageKey}
          onClick={() => handleLanguageChange(languageKey)}
        >
          {LANGUAGES[languageKey]}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};
